import {
  Braces, Code2, Database, File, FileCode2, FileJson2, FileText, GitBranch,
  ScrollText,
} from 'lucide-react'
import { cn } from '@/lib/utils'
import type { RepositoryFile } from '@/frontend/features/Fde/types'

const visualByExtension: Record<string, { icon: typeof File; tone: string; label: string }> = {
  md: { icon: FileText, tone: 'bg-violet-500/10 text-violet-600', label: 'MD' },
  markdown: { icon: FileText, tone: 'bg-violet-500/10 text-violet-600', label: 'MD' },
  json: { icon: FileJson2, tone: 'bg-amber-500/10 text-amber-700', label: 'JSON' },
  jsonl: { icon: FileJson2, tone: 'bg-amber-500/10 text-amber-700', label: 'JSONL' },
  xml: { icon: Code2, tone: 'bg-orange-500/10 text-orange-700', label: 'XML' },
  sql: { icon: Database, tone: 'bg-blue-500/10 text-blue-700', label: 'SQL' },
  mmd: { icon: GitBranch, tone: 'bg-cyan-500/10 text-cyan-700', label: 'MMD' },
  mermaid: { icon: GitBranch, tone: 'bg-cyan-500/10 text-cyan-700', label: 'MMD' },
  yml: { icon: Braces, tone: 'bg-rose-500/10 text-rose-700', label: 'YML' },
  yaml: { icon: Braces, tone: 'bg-rose-500/10 text-rose-700', label: 'YAML' },
  txt: { icon: ScrollText, tone: 'bg-slate-500/10 text-slate-600', label: 'TXT' },
}

export function workspaceFileVisual(file: Pick<RepositoryFile, 'extension'>) {
  return visualByExtension[file.extension] || {
    icon: file.extension ? FileCode2 : File,
    tone: 'bg-slate-500/10 text-slate-600',
    label: file.extension.toUpperCase() || 'FILE',
  }
}

export function WorkspaceFileIcon({ file, className }: { file: Pick<RepositoryFile, 'extension'>; className?: string }) {
  const visual = workspaceFileVisual(file)
  const Icon = visual.icon
  return <span className={cn('flex size-10 shrink-0 items-center justify-center rounded-xl', visual.tone, className)}><Icon className="size-5" /></span>
}

export function formatFileSize(bytes: number) {
  if (bytes < 1_000) return `${bytes} B`
  if (bytes < 1_000_000) return `${Math.round(bytes / 1_000)} KB`
  return `${(bytes / 1_000_000).toFixed(1)} MB`
}
